var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserAmbassador(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.95 6.85714H23V9.14286H14.95V6.85714ZM16.1 11.4286H23V13.7143H16.1V11.4286ZM13.8 2.28571H23V4.57143H13.8V2.28571ZM2.3 16H13.8V14.8571C13.8 11.7063 11.2205 9.14286 8.05 9.14286H5.75C2.57945 9.14286 0 11.7063 0 14.8571V16H2.3ZM6.9 8C9.19425 8 10.925 6.28 10.925 4C10.925 1.72 9.19425 0 6.9 0C4.60575 0 2.875 1.72 2.875 4C2.875 6.28 4.60575 8 6.9 8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAmbassador);
export default __webpack_public_path__ + "static/media/user-ambassador.9fcc0e47.svg";
export { ForwardRef as ReactComponent };